import { http } from "@/providers/http";
export class FlagApplicantApi {
  private static INSTANCE = new FlagApplicantApi();

  static get instance() {
    return this.INSTANCE;
  }

  public peersFlag(data: any) {
    const endpoint = "cprs/peers/flag";
    const headers = http.getTokenHeaders();
    return http
      .post(endpoint, headers, data)
      .then((response) => {
        return response;
      })
      .catch((err) => {
        return err;
      });
  }

  public peersFlagHistory(id: any) {
    const endpoint = "cprs/peers/flag";
    const headers = http.getTokenHeaders();
    return http
      .get(endpoint, headers, id)
      .then((response) => {
        return response;
      })
      .catch((err) => {
        return err;
      });
  }

  public getFlagHistory(params: { id?: string; email?: string }) {
    const endpoint = "cprs/peers/flag";
    const headers = http.getTokenHeaders();
    return http
      .get(endpoint, headers, params)
      .then((response) => response.data?.flags);
  }
  public FlagCertificateRevoke(data: any) {
    const endpoint = "cprs/certificate/revoke";
    const headers = http.getTokenHeaders();
    return http
      .put(endpoint, headers, data)
      .then((response) => {
        return response;
      })
      .catch((err) => {
        return err;
      });
  }
  public peersDisable(data: any) {
    const endpoint = "cprs/peers/disable";
    const headers = http.getTokenHeaders();
    return http
      .put(endpoint, headers, data)
      .then((response) => {
        return response;
      })
      .catch((err) => {
        return err;
      });
  }
}
export const flagApplicantApi = FlagApplicantApi.instance;
